import * as Sugar from 'sugar';
require('sugar/locales/ja.js');
import { Base64 } from 'js-base64';
import { jsonp } from './jsonp';
import { OmotenashiContentsData } from './OmotenashiContentsData';
import { OmotenashiContentsHtml } from './OmotenashiContentsHtml';

/**
 * グローバル定義
 */
declare global {
  /**
   * どこどこJPの位置情報型（参照プロパティのみ定義）
   *
   * @param {string} key どこどこJPのAPIキー又はdummy
   * @param {string} PrefCode 都道府県コード
   * @param {string} PrefCF 都道府県のCF値（緯度経度判定の場合は99、IPアドレス判定の場合は99より小さい値）
   * @see https://www.docodoco.jp/api/latlon/
   */
  interface SURFPOINT {
    key: string;
    PrefCode: string;
    PrefCF: string;
  }

  /**
   * @description ビルトインLocationオブジェクトの追加プロパティ
   * @param {string:string} param URLパラメータのキー・バリュー
   */
  interface Location {
    param: { [index: string]: string };
  }

  /** @type {string} どこどこJPのAPIキー */
  var docodoco_key: string;

  /** @type {*} Geolocation APIの設定値（PositionOptionsオブジェクト） */
  var geolocationapi_op: {};

  /** @type {(SURFPOINT) => void} 位置情報取得後のコールバック関数 */
  var callback_docodoco: (a: SURFPOINT) => void;

  /** @type {SURFPOINT} SURFPOINT 緯度経度が取得できなかった場合の位置情報が格納される（IPアドレス判定） */
  var SURFPOINT: SURFPOINT;

  /** @type {SURFPOINT} SURFPOINT_latlon 緯度経度が取得できた場合の位置情報が格納される（緯度経度判定）*/
  var SURFPOINT_latlon: SURFPOINT;
}

/**
 * おもてなしコンテンツ®設定
 *
 * @see https://api.docodoco.jp/search_latlon.js
 */
export function OmotenashiContents(): void {
  // おもてなしコンテンツ設置ページのみ実行
  if (!$('.omotenashi-contents').length) {
    return;
  } else {
    $('.omotenashi-contents').replaceWith(OmotenashiContentsHtml);
  }

  // URLパラメータを取得する
  setLocationParam();

  // どこどこJPのAPIキー設定
  window.docodoco_key = 'dM4ipYl6ExYO0Sb2L1rBBgg5mtX7hX1NPMvVGgixbSMVZci8wUlv4OTCWXcvB4WT';

  // Geolocation APIの設定値
  window.geolocationapi_op = {
    enableHighAccuracy: true, // 可能な限り高精度の結果を求める設定
    timeout: 5 * 1000, // 位置情報の取得にかかる時間の上限(ミリ秒)
    maximumAge: 5 * 60 * 1000, // キャッシュ済みの位置情報の有効期限(ミリ秒)
  };

  // 位置情報取得後のコールバック関数を設定
  window.callback_docodoco = (SURFPOINT_latlon: SURFPOINT) => {
    setOmotenashiContents(SURFPOINT_latlon);
  };

  return;
}

/**
 * おもてなしコンテンツ®メイン処理
 */
function setOmotenashiContents(SURFPOINT_latlon: SURFPOINT): void {
  const dataurl = 'https://www.omotenashi-contents.jp/data/weather/';
  const extstr = '.xml';
  const prefname: { [key: string]: string } = { '01': '北海道', '02': '青森県', '03': '岩手県', '04': '宮城県', '05': '秋田県', '06': '山形県', '07': '福島県', '08': '茨城県', '09': '栃木県', '10': '群馬県', '11': '埼玉県', '12': '千葉県', '13': '東京都', '14': '神奈川県', '15': '新潟県', '16': '富山県', '17': '石川県', '18': '福井県', '19': '山梨県', '20': '長野県', '21': '岐阜県', '22': '静岡県', '23': '愛知県', '24': '三重県', '25': '滋賀県', '26': '京都府', '27': '大阪府', '28': '兵庫県', '29': '奈良県', '30': '和歌山県', '31': '鳥取県', '32': '島根県', '33': '岡山県', '34': '広島県', '35': '山口県', '36': '徳島県', '37': '香川県', '38': '愛媛県', '39': '高知県', '40': '福岡県', '41': '佐賀県', '42': '長崎県', '43': '熊本県', '44': '大分県', '45': '宮崎県', '46': '鹿児島県', '47': '沖縄県' };
  const prefname_en: { [key: string]: string } = { '01': 'Hokkaido', '02': 'Aomori', '03': 'Iwate', '04': 'Miyagi', '05': 'Akita', '06': 'Yamagata', '07': 'Fukushima', '08': 'Ibaraki', '09': 'Tochigi', '10': 'Gunma', '11': 'Saitama', '12': 'Chiba', '13': 'Tokyo', '14': 'Kanagawa', '15': 'Niigata', '16': 'Toyama', '17': 'Ishikawa', '18': 'Fukui', '19': 'Yamanashi', '20': 'Nagano', '21': 'Gifu', '22': 'Shizuoka', '23': 'Aichi', '24': 'Mie', '25': 'Shiga', '26': 'Kyoto', '27': 'Osaka', '28': 'Hyogo', '29': 'Nara', '30': 'Wakayama', '31': 'Tottori', '32': 'Shimane', '33': 'Okayama', '34': 'Hiroshima', '35': 'Yamaguchi', '36': 'Tokushima', '37': 'Kagawa', '38': 'Ehime', '39': 'Kochi', '40': 'Fukuoka', '41': 'Saga', '42': 'Nagasaki', '43': 'Kumamoto', '44': 'Oita', '45': 'Miyazaki', '46': 'Kagoshima', '47': 'Okinawa' };
  const prefcf: { [key: string]: number } = { '01': 71, '02': 81, '03': 81, '04': 71, '05': 81, '06': 81, '07': 81, '08': 61, '09': 81, '10': 61, '11': 81, '12': 71, '13': 61, '14': 61, '15': 81, '16': 81, '17': 81, '18': 81, '19': 81, '20': 61, '21': 71, '22': 71, '23': 61, '24': 81, '25': 81, '26': 61, '27': 61, '28': 71, '29': 81, '30': 71, '31': 71, '32': 81, '33': 81, '34': 61, '35': 81, '36': 81, '37': 81, '38': 71, '39': 81, '40': 71, '41': 81, '42': 81, '43': 81, '44': 81, '45': 61, '46': 81, '47': 81 };
  const now: sugarjs.Date.ChainableBase<Date> = new Sugar.Date();
  const hour: number = now.getHours().raw;
  const nord = hour >= 21 || hour <= 3 ? 'n' : 'd';
  const dowClass = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  // URLから施設を特定してデータを取得する
  const folderName = location.pathname.split('/')[1];
  const data = OmotenashiContentsData.find((v) => v.folderName === folderName);
  const prefdef = data?.prefCode || ''; // 該当施設の都道府県コード
  const defcode = data?.areaCode || ''; // 該当施設の地域コード

  let flag = false; // 判定フラグ
  let pref = prefdef; // 都道府県コード
  let cf = 0; // 都道府県コードの正確性閾値

  // 該当施設の地域名を表示
  $('.omotenashi-contents .place-name').text(data?.areaName || '');

  // どこどこJPの判定結果を設定
  if (Object.keys(SURFPOINT_latlon).length && SURFPOINT_latlon.key !== 'dummy') {
    pref = SURFPOINT_latlon.PrefCode;
    cf = parseInt(SURFPOINT_latlon.PrefCF);
    flag = true;
  }

  // パラメータ指定の場合は優先する
  if (location.param?.pref) {
    pref = location.param.pref;
    cf = 100;
  }

  // CF値が閾値より低い場合はデフォルトにする
  if (cf < prefcf[pref]) {
    flag = false;
    pref = prefdef;
  }

  // デフォルト県の天気情報を取得して表示する
  jsonp(dataurl + defcode + extstr, function (data, status) {
    let data_str: string = Base64.decode(data.data);
    let xml = $.parseXML(data_str);
    let table = $('.omotenashi-contents-weather-place table');
    let lastAnnounce = $(xml).find('announce').attr('lastAnnounce');
    let update = new Sugar.Date(lastAnnounce);
    $('.omotenashi-contents-update').text(update.format('{M}/{dd} {HH}時発表').raw);

    for (let i = 0; i <= 2; i++) {
      let f = $(xml).find('forecast').eq(i);
      let icon = f.find('outlook casualCode').text() + nord;
      let alt = f.find('outlook name').text();
      let max = $(f).find('temperature high').text() + '&#8451;';
      let min = $(f).find('temperature low').text() + '&#8451;';

      // 天気と気温の行を設定する
      let target = table.find('tr.weather-icon-temp td:eq(' + i + ')');
      target.find('img').attr({
        'src': '/omotenashi-contents/weather/' + icon + '.png',
        'alt': alt,
      });
      target.find('span.temp-max').html(max);
      target.find('span.temp-min').html(min);

      // 日付の行を設定する
      const week = table.find('tr.weather-date-dow th:eq(' + (i + 1) + ')');
      let dco: sugarjs.Date.DateCreateOptions = { locale: 'ja' };
      let dt = new Sugar.Date(f.attr('date'), dco);
      week.find('.date').text(dt.format('{M}/{d}', 'ja').raw);
      week.find('.dow').text(dt.format('({dow})', 'ja').replace('曜日', '').raw);
      week.addClass(dowClass[dt.getWeekday().raw]);
    }
  });

  // アクセス県の天気情報を取得して表示する
  if (pref !== prefdef) {
    jsonp(dataurl + pref + extstr, function (data, status) {
      let data_str: any = Base64.decode(data.data);
      let xml = $.parseXML(data_str);
      let table = $('.omotenashi-contents-weather-from table');

      table.find('.from-name').text(prefname[pref]);

      for (let i = 0; i <= 2; i++) {
        let f = $(xml).find('forecast').eq(i);
        let icon = f.find('outlook casualCode').text() + nord;
        let alt = f.find('outlook name').text();
        let max = $(f).find('temperature high').text() + '&#8451;';
        let min = $(f).find('temperature low').text() + '&#8451;';

        // 天気と気温の行を設定する
        let target = table.find('tr.weather-icon-temp td:eq(' + i + ')');
        target.find('img').attr({
          'src': '/omotenashi-contents/weather/' + icon + '.png',
          'alt': alt,
        });
        target.find('span.temp-max').html(max);
        target.find('span.temp-min').html(min);

        // 日付の行を設定する
        const week = table.find('tr.weather-date-dow th:eq(' + (i + 1) + ')');
        let dco: sugarjs.Date.DateCreateOptions = { locale: 'ja' };
        let dt = new Sugar.Date(f.attr('date'), dco);
        week.find('.date').text(dt.format('{M}/{d}', 'ja').raw);
        week.find('.dow').text(dt.format('({dow})', 'ja').replace('曜日', '').raw);
        week.addClass(dowClass[dt.getWeekday().raw]);
      }
    });
  } else {
    $('.omotenashi-contents-weather-from').hide();
  }

  // 見出しを表示する
  let ttl;
  if (pref == prefdef || typeof prefname[pref] == 'undefined') {
    ttl = '皆さまのご来館を<br class="sumaho">お待ちしております';
  } else {
    ttl = prefname[pref] + 'からのご来館を<br class="sumaho">お待ちしております';
  }
  $('.omotenashi-contents-ttl').html(ttl);

  // 簡易アクセス経路図を表示する
  $('.omotenashi-contents-access img').attr({
    'src': '/omotenashi-contents/access/' + folderName + '/' + pref + '.svg',
    'alt': prefname[pref] + 'からの簡易アクセス経路図',
  });
}

/**
 * URLクエリパラメータをキーバリューに分割する
 */
function setLocationParam(): void {
  if (location.search) {
    const r: RegExpMatchArray = location.search.match(/([^?&]+=?[^?&]+)/g) || [];
    $.each(r, (i, v) => {
      const s: string[] = v.split('=');
      location.param = {};
      location.param[s[0]] = decodeURIComponent(s[1]);
    });
  }
}
